import { type FirebaseFirestoreInfra } from "@/infrastructure/firebase_firestore/core/firestore"
import { getDoc } from "firebase/firestore"

import { AppConfig } from "../../entities/app_config/app_config"

export class AppConfigRepository {
  constructor(private readonly firestore: FirebaseFirestoreInfra) {}

  private documentReference() {
    return this.firestore.documentReference<AppConfig>(
      AppConfig.firestore.documentPath()
    )
  }

  async fetch(): Promise<AppConfig> {
    const snapshot = await getDoc(this.documentReference())

    return snapshot.data()!
  }
}
